import React from 'react';
import { SelectWrapper, StyledArrowSvg, StyledSelect } from '@components/Select/Select.styles';

export interface SelectProps<T> {
  className?: string;
  value: T | '';
  options: ReadonlyArray<T>;
  labelFunction: (value: T) => string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const Select = <T extends string>({ value, options, className, labelFunction, ...restProps }: SelectProps<T>) => {
  return (
    <SelectWrapper className={className}>
      <StyledArrowSvg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.2525 8.80122C18.4868 9.03554 18.4868 9.41544 18.2525 9.64975L13.1312 14.7711C12.5063 15.3959 11.4933 15.3959 10.8684 14.7711L5.74898 9.65162C5.51466 9.41731 5.51466 9.03741 5.74898 8.80309C5.98329 8.56878 6.36319 8.56878 6.59751 8.80309L11.717 13.9225C11.8732 14.0788 12.1264 14.0788 12.2826 13.9225L17.404 8.80122C17.6383 8.56691 18.0182 8.56691 18.2525 8.80122Z"
          fill="#333333"
        />
      </StyledArrowSvg>
      <StyledSelect value={value} {...restProps}>
        <option value="">All</option>
        {options.map(option => (
          <option key={option} value={option}>
            {labelFunction(option)}
          </option>
        ))}
      </StyledSelect>
    </SelectWrapper>
  );
};
